import { render, staticRenderFns } from "./PublicInput.vue?vue&type=template&id=4c0f0e96&scoped=true&"
import script from "./PublicInput.vue?vue&type=script&lang=js&"
export * from "./PublicInput.vue?vue&type=script&lang=js&"
import style0 from "./PublicInput.vue?vue&type=style&index=0&id=4c0f0e96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f0e96",
  null
  
)

export default component.exports